<template>
  <div class="form-group row">
    <label class="col-form-label col-lg-2">Emails</label>
    <div class="col-lg-10">
      <div v-for="(email, index) in emails" :key="index" class="mb-3">
        <div class="input-group">
          <input
            type="email"
            class="form-control"
            placeholder="Email Address"
            v-model="email.emailAddress"
            @input="emitUpdate"
          />
          <div class="input-group-append">
            <select
              class="input-group-text form-control bg-light"
              v-model="email.emailType"
              @change="emitUpdate"
            >
              <option value="PRIMARY">Primary</option>
              <option value="WORK">Work</option>
              <option value="OTHER">Other</option>
            </select>
          </div>
          <div class="input-group-append" v-if="allowMultiple && emails.length > 1">
            <button
              class="btn btn-outline-danger"
              type="button"
              style="z-index: auto; border: 1px solid #ced4da;"
              @click="removeEmail(index)"
            >
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="mt-2" v-if="allowMultiple && canAddMore">
        <a href="#" class="text-primary" @click.prevent="addEmail">
          <i class="fas fa-plus-circle mr-1"></i> Add another email
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmailAddressesSection',
  props: {
    value: {
      type: Array,
      required: true
    },
    maxItems: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      emails: []
    };
  },
  computed: {
    allowMultiple() {
      return this.maxItems === null || this.maxItems > 1;
    },
    canAddMore() {
      if (this.maxItems === null) return true;
      return this.emails.length < this.maxItems;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.emails = newVal;
      },
      deep: true
    }
  },
  methods: {
    emitUpdate() {
      this.$emit('input', this.emails);
    },
    addEmail() {
      this.emails.push({
        emailAddress: "",
        emailType: "PRIMARY"
      });
      this.emitUpdate();
    },
    removeEmail(index) {
      this.emails.splice(index, 1);
      this.emitUpdate();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ContactDetails/sections/EmailAddressesSection.vue